<template>
	<div>
		<div class="upload-images-box">
			<el-upload
				v-show="uploadFileList.length < limit"
				ref="uploadImagesRef"
				class="images-uploader"
				:action="action"
				:data="data"
				:headers="headers"
				:accept="accept"
				:limit="limit"
				:show-file-list="false"
				:before-upload="beforeImagesUpload"
				:on-exceed="handleExceed"
				:on-success="handleImagesSuccess"
				:on-error="handleImagesError"
				:disabled="isDisabled"
				v-bind="$attrs"
			>
				<i slot="trigger" class="el-icon-plus images-uploader-icon"></i>
				<div v-if="isUploading" class="upload-loading-mask">
					<i class="el-icon-loading"></i>
				</div>
			</el-upload>

			<div class="upload-images-list">
				<div v-for="(item, index) in uploadFileList" :key="index" class="upload-images">
					<el-image
						ref="imageRef"
						:src="item.url"
						:preview-src-list="uploadFileList.map(item => item.url)"
						:initial-index="index"
						class="upload-image-item"
					></el-image>
					<div class="upload-mask">
						<div class="actions">
							<i class="action-icon el-icon-zoom-in" @click="previewImage(index)"></i>
							<i class="action-icon el-icon-delete" @click="deleteImage(index)"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="tip" class="images-uploader-tip">
			最多上传{{ limit }}张图片，大小不能超过{{ size }}MB，且仅支持{{ accept }}格式
		</div>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'

	export default {
		name: 'UploadImages',
		components: {},
		inheritAttrs: false,
		model: {
			prop: 'modelValue',
			event: 'update:modelValue'
		},
		props: {
			headers: {
				type: Object,
				default: () => ({})
			},
			action: {
				type: String,
				required: true
			},
			data: {
				type: Object,
				default: () => ({})
			},
			limit: {
				type: Number,
				default: 1
			},
			size: {
				type: Number,
				default: 5
			},
			accept: {
				type: String,
				default: '.jpg,.jpeg,.png,.gif,.webp'
			},
			tip: {
				type: Boolean,
				default: false
			},
			modelValue: {
				type: Array,
				default: () => []
			},
			queryApi: {
				type: Function,
				default: null
			},
			deleteApi: {
				type: Function,
				default: null
			},
			queryParams: {
				type: Object,
				default: () => ({})
			},
			deleteParams: {
				type: Object,
				default: () => ({})
			},
			previewUrl: {
				type: String,
				default: ''
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				uploadFileList: [],
				isUploading: false
			}
		},
		computed: {
			isDisabled() {
				if (this.disabled) return true
				let parent = this.$parent
				while (parent) {
					const parentProps = parent.$options.propsData || {}
					if (parentProps.disabled !== undefined) {
						return parentProps.disabled
					}
					parent = parent.$parent
				}
				return false
			}
		},
		watch: {
			modelValue: {
				handler(newVal) {
					if (newVal && Array.isArray(newVal)) {
						this.uploadFileList = [...newVal]
					}
				},
				immediate: true,
				deep: true
			}
		},
		mounted() {
			// this.loadImages()
		},
		methods: {
			/**
			 * 上传图片前的校验
			 * @param {File} file 上传的文件
			 * @returns {boolean} 是否校验通过
			 */
			beforeImagesUpload(file) {
				const fileExtension =
					'.' +
					file.name
						.split('.')
						.pop()
						.toLowerCase()
				const allowedExtensions = this.accept.split(',').map(ext => ext.trim().toLowerCase())
				const isImage = allowedExtensions.includes(fileExtension)
				const isSize = file.size / 1024 / 1024 < this.size

				if (!isImage) {
					this.$message.error(`上传图片只能是${this.accept}格式!`)
				}
				if (!isSize) {
					this.$message.error(`上传图片大小不能超过${this.size}MB!`)
				}
				if (isImage && isSize) {
					this.isUploading = true
				}
				return isImage && isSize
			},

			/**
			 * 超出上传数量的处理
			 */
			handleExceed() {
				this.$message.error(`最多只能上传${this.limit}张图片!`)
			},

			/**
			 * 上传图片成功的处理
			 * @param {object} res 上传成功的响应数据
			 * @param {File} file 上传的文件
			 */
			handleImagesSuccess(res, file) {
				this.isUploading = false
				if (res.code === 200) {
					const imageFileId = res.data
					if (imageFileId && this.previewUrl) {
						const imageUrl = this.previewUrl + imageFileId
						const imageFileObj = {
							fileId: imageFileId,
							url: imageUrl
						}
						this.uploadFileList.push(imageFileObj)
						this.$emit('update:modelValue', this.uploadFileList)
						this.$emit('uploadSuccess', imageFileObj, this.uploadFileList)
						this.$message.success('上传成功')
					} else {
						console.error('上传成功但未返回图片id或未配置预览地址')
					}
				} else {
					this.$message.error(res.msg || '上传失败')
				}
			},

			/**
			 * 上传图片失败的处理
			 */
			handleImagesError() {
				this.isUploading = false
			},

			/**
			 * 预览图片
			 * @param {number} index 图片索引
			 */
			previewImage(index) {
				const imageInstance = this.$refs.imageRef && this.$refs.imageRef[index]
				if (imageInstance) {
					imageInstance.clickHandler()
				}
			},

			/**
			 * 删除图片
			 * @param {number} index 图片索引
			 */
			deleteImage(index) {
				const imageItem = this.uploadFileList[index]
				MessageBox.confirm('确定要删除这张图片吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						if (this.deleteApi) {
							return this.deleteApi({ ...this.deleteParams, fileRecordId: imageItem.fileId })
								.then(() => {
									this.uploadFileList.splice(index, 1)
								})
								.catch(error => {
									console.error('删除图片失败:', error)
									throw error
								})
						} else {
							this.uploadFileList.splice(index, 1)
							return Promise.resolve()
						}
					})
					.then(() => {
						this.$emit('update:modelValue', this.uploadFileList)
						this.$emit('deleteSuccess', imageItem, this.uploadFileList)
						this.$message.success('删除成功')
					})
					.catch(error => {
						if (error !== 'cancel') {
							this.$message.error('删除失败')
						}
					})
			},

			/**
			 * 加载图片
			 */
			loadImages() {
				if (this.queryApi) {
					this.queryApi({ ...this.queryParams })
						.then(res => {
							if (res.code === 200 && res.data) {
								const images = res.data.map(item => ({
									fileId: item.id,
									url: this.previewUrl + item.id
								}))
								this.uploadFileList = images
								this.$emit('update:modelValue', this.uploadFileList)
							}
						})
						.catch(error => {
							console.error('加载图片失败:', error)
						})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.upload-images-box {
		display: flex;
		flex-wrap: wrap;

		::v-deep .el-upload {
			position: relative;
			overflow: hidden;
			cursor: pointer;
			border: 1px dashed #cccccc;
			border-radius: 4px;
			transition: all 0.3s;

			&:hover {
				border-color: #409eff;
			}

			.images-uploader-icon {
				width: 70px;
				height: 70px;
				line-height: 70px;
				font-size: 28px;
				color: #8c939d;
				text-align: center;
			}

			&.is-disabled {
				cursor: not-allowed;

				&:hover {
					border-color: #cccccc;
				}
			}
		}

		.images-uploader {
			position: relative;
			margin-right: 10px;
			margin-bottom: 10px;

			.upload-loading-mask {
				position: absolute;
				top: 1px;
				right: 1px;
				bottom: 1px;
				left: 1px;
				z-index: 1;
				display: flex;
				align-items: center;
				justify-content: center;
				background: rgba(255, 255, 255, 0.8);

				.el-icon-loading {
					font-size: 24px;
					color: #409eff;
				}
			}
		}
	}

	.upload-images-list {
		display: flex;
		flex-wrap: wrap;
	}

	.upload-images {
		position: relative;
		display: inline-block;
		width: 70px;
		height: 70px;
		margin-right: 10px;
		margin-bottom: 10px;
		background: #ffffff;
		border: 1px solid #e1e1e1;
		border-radius: 4px;

		.upload-image-item {
			width: 100%;
			height: 100%;
			object-fit: fill;
		}

		.upload-mask {
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.4);
			opacity: 0;
			transition: all 0.3s;

			.actions {
				display: flex;
				align-items: center;
				justify-content: center;

				.action-icon {
					margin: 0 5px;
					font-size: 22px;
					color: #ffffff;
					cursor: pointer;
				}
			}
		}

		&:hover .upload-mask {
			opacity: 1;
		}
	}

	.images-uploader-tip {
		margin-top: 8px;
		font-size: 12px;
		color: #606266;
	}
</style>
